var map = {
  "./code-example/element.js": [
    "84352",
    [
      7489,
      1861,
      1598,
      7065
    ]
  ],
  "./dropdown/element.js": [
    "58623",
    [
      2868
    ]
  ],
  "./live-sample-result/element.js": [
    "47849",
    [
      7489,
      3708,
      5950,
      4098,
      1861,
      8401
    ]
  ],
  "./observatory-tests-and-scores/element.js": [
    "56538",
    [
      6407
    ]
  ],
  "./play-runner/element.js": [
    "63657",
    [
      7489,
      5950,
      4098,
      1721
    ]
  ],
  "./search-button/element.js": [
    "23745",
    [
      3690
    ]
  ],
  "./survey/element.js": [
    "10423",
    [
      7489,
      8121,
      5196
    ]
  ],
  "./ix-tab-wrapper/element.js": [
    "49979",
    [
      2568
    ]
  ],
  "./placement-sidebar/element.js": [
    "57468",
    [
      7489,
      3708,
      8280,
      1477,
      4249,
      2173
    ]
  ],
  "./placement-hp-main/element.js": [
    "44394",
    [
      7489,
      3708,
      8280,
      1477,
      4249,
      4759
    ]
  ],
  "./record-visit/element.js": [
    "55237",
    [
      5562,
      3094
    ]
  ],
  "./toggle-sidebar/element.js": [
    "39337",
    [
      9234
    ]
  ],
  "./user-menu/element.js": [
    "74354",
    [
      2868,
      8121,
      3711
    ]
  ],
  "./interactive-example/element.js": [
    "79879",
    [
      7489,
      749,
      8520,
      3649,
      6216,
      2080,
      640,
      9515,
      2135,
      5950,
      4098,
      3818,
      3047,
      1861,
      2448,
      1598,
      4419,
      7065,
      2568,
      5338,
      9404
    ]
  ],
  "./copy-button/element.js": [
    "65517",
    [
      1598
    ]
  ],
  "./observatory-comparison-table/element.js": [
    "50117",
    [
      8160,
      2006
    ]
  ],
  "./sidebar-filter/element.js": [
    "50128",
    [
      169
    ]
  ],
  "./issues-table/element.js": [
    "37511",
    [
      4204
    ]
  ],
  "./scrim-inline/element.js": [
    "33878",
    [
      7489,
      3708,
      1691
    ]
  ],
  "./switch/element.js": [
    "41798",
    [
      9099
    ]
  ],
  "./collection-save-button/element.js": [
    "1355",
    [
      3980,
      4920
    ]
  ],
  "./contributor-list/element.js": [
    "23082",
    [
      9127
    ]
  ],
  "./button/element.js": [
    "35268",
    []
  ],
  "./homepage-search/element.js": [
    "27373",
    [
      7678
    ]
  ],
  "./modal/element.js": [
    "14903",
    [
      3980
    ]
  ],
  "./color-theme/element.js": [
    "55269",
    [
      2868,
      5542
    ]
  ],
  "./about-team-member/element.js": [
    "612",
    [
      8981
    ]
  ],
  "./content-feedback/element.js": [
    "65929",
    [
      7938
    ]
  ],
  "./play-console/element.js": [
    "56369",
    [
      3818
    ]
  ],
  "./ix-tab/element.js": [
    "18977",
    [
      4419,
      5338
    ]
  ],
  "./observatory-header-link/element.js": [
    "1879",
    [
      8160,
      3676
    ]
  ],
  "./curriculum-tabs/element.js": [
    "52500",
    [
      9717
    ]
  ],
  "./placement-bottom/element.js": [
    "7895",
    [
      7489,
      3708,
      8280,
      1477,
      4249,
      4060
    ]
  ],
  "./image-history/element.js": [
    "47706",
    [
      1975
    ]
  ],
  "./not-found/element.js": [
    "2622",
    [
      8926,
      3555
    ]
  ],
  "./placement-note/element.js": [
    "47764",
    [
      1477
    ]
  ],
  "./compat-table-lazy/element.js": [
    "96678",
    [
      7489,
      8121,
      8067,
      251
    ]
  ],
  "./site-search/element.js": [
    "53163",
    [
      9784
    ]
  ],
  "./placement-no/element.js": [
    "13755",
    [
      8280
    ]
  ],
  "./play-controller/element.js": [
    "23731",
    [
      2448
    ]
  ],
  "./placement-top/element.js": [
    "9951",
    [
      7489,
      3708,
      8280,
      1477,
      4249,
      9204
    ]
  ],
  "./observatory-form/element.js": [
    "17547",
    [
      7489,
      6110,
      1672
    ]
  ],
  "./observatory-results/element.js": [
    "23247",
    [
      2868,
      8160,
      6110,
      2006,
      3676,
      921,
      4070,
      9764
    ]
  ],
  "./about-tabs/element.js": [
    "54842",
    [
      7047
    ]
  ],
  "./observatory-human-duration/element.js": [
    "37077",
    [
      8160,
      4070
    ]
  ],
  "./playground/element.js": [
    "28940",
    [
      7489,
      749,
      8520,
      3649,
      6216,
      2080,
      640,
      9515,
      5950,
      4098,
      3818,
      3047,
      2448,
      3980,
      3416
    ]
  ],
  "./ix-tab-panel/element.js": [
    "89854",
    [
      4419
    ]
  ],
  "./play-editor/element.js": [
    "63386",
    [
      749,
      8520,
      3649,
      6216,
      2080,
      640,
      9515,
      5950,
      3047
    ]
  ],
  "./themed-image/element.js": [
    "48125",
    [
      5102
    ]
  ],
  "./writer-open-editor/element.js": [
    "51310",
    [
      1315
    ]
  ],
  "./progress-bar/element.js": [
    "20141",
    [
      6110
    ]
  ],
  "./compat-table/element.js": [
    "7086",
    [
      7489,
      8121,
      8067
    ]
  ],
  "./login-button/element.js": [
    "70242",
    [
      6319
    ]
  ],
  "./observatory-rescan-button/element.js": [
    "14416",
    [
      921,
      3140
    ]
  ],
  "./recently-visited/element.js": [
    "95821",
    [
      5562,
      5246
    ]
  ],
  "./language-always-redirect-button/element.js": [
    "77108",
    [
      9647,
      5685
    ]
  ],
  "./language-switcher/element.js": [
    "48423",
    [
      2868,
      9099,
      9647,
      8926,
      1996
    ]
  ],
  "./search-modal/element.js": [
    "97154",
    []
  ],
  "./writer-reload/element.js": [
    "14925",
    [
      4366
    ]
  ]
};
function __rspack_async_context(req) {
  if(!__webpack_require__.o(map, req)) {
    return Promise.resolve().then(() => {
var e = new Error("Cannot find module '" + req + "'");
e.code = 'MODULE_NOT_FOUND';
throw e;
});
  }

  var ids = map[req], id = ids[0];
  return Promise.all(ids[1].map(function(chunkId) { return __webpack_require__.e(chunkId); })).then(() => (__webpack_require__(id)));
}

__rspack_async_context.keys = () => (Object.keys(map));
__rspack_async_context.id = 95061;
module.exports = __rspack_async_context;
